import styled, { css } from '../theme/styled';
import { StylePropsComplex } from './svg';

export const Wrapper = styled.div.attrs({
  className: 'svg-viewer',
})<StylePropsComplex>`
  ${({
    color = 'inherit',
    hoverColor = 'inherit',
    cursor = 'inherit',
    size = '16px',
    deg = 0,
    isMirror = false,
    theme,
  }) => css`
    width: ${size};
    height: ${size};
    rotate: ${deg}deg;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${cursor};

    transform: ${isMirror ? 'rotate(-180deg)' : 'none'};
    transition-duration: ${theme.tokens.animation.duration.base};

    & svg {
      & > path:not([stroke]),
      & > circle:not([stroke]) {
        transition-duration: ${theme.tokens.animation.duration.base};
        fill: ${color === 'inherit' ? 'currentColor' : color};
      }
    }

    &:hover {
      & > svg > path:not([stroke]),
      & > svg > circle:not([stroke]) {
        fill: ${hoverColor === 'inherit'
          ? color === 'inherit'
            ? 'currentColor'
            : color
          : hoverColor};
      }
    }
  `};
`;

export const ComplexWrapper = styled.div.attrs({
  className: 'complex-svg__wrapper',
})<StylePropsComplex>`
  ${({
    color = 'inherit',
    hoverColor = 'inherit',
    subColor = 'inherit',
    subHoverColor = 'inherit',
    cursor = 'inherit',
    size = '16px',
    deg = 0,
    isMirror = false,
    theme,
  }) => css`
    width: ${size};
    height: ${size};
    rotate: ${deg}deg;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${cursor};

    transform: ${isMirror ? 'rotate(180deg)' : 'none'};
    transition-duration: ${theme.tokens.animation.duration.base};

    & svg > g {
      & > path,
      & > circle {
        transition-duration: ${theme.tokens.animation.duration.base};
        fill: ${color === 'inherit' ? 'currentColor' : color};

        &:last-child {
          fill: ${subColor === 'inherit' ? 'currentColor' : subColor};
        }
      }
    }

    &:hover {
      & > svg > g > path,
      & > svg > g > circle {
        fill: ${hoverColor === 'inherit' ? 'currentColor' : hoverColor};

        &:last-child {
          fill: ${subHoverColor === 'inherit' ? 'currentColor' : subHoverColor};
        }
      }
    }
  `}
`;
